"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable-next-line:import-name

var anatomogram_1 = require("anatomogram");

var React = require("react");

var immutable_1 = require("immutable");

var context_1 = require("../context");

exports.springToAnatomogramMapping = {
  homo_sapiens: {
    P11A: 'UBERON_0000178',
    P11B: 'UBERON_0001155',
    P12A: 'UBERON_0000955',
    P9A: 'UBERON_0000977'
  },
  mus_musculus: {
    Bladder: 'UBERON_0001255',
    Heart: 'UBERON_0000948',
    Kidney: 'UBERON_0002113',
    Limb: 'UBERON_0014892',
    Liver: 'UBERON_0002107',
    Lung: 'UBERON_0002048',
    Mammary: 'UBERON_0001911',
    Marrow: 'UBERON_0002371',
    Muscle: 'UBERON_0014892',
    Spleen: 'UBERON_0002106',
    Thymus: 'UBERON_0002370',
    Tongue: 'UBERON_0001723',
    Trachea: 'UBERON_0003126'
  }
};
exports.anatomogramToSpringMapping = {
  homo_sapiens: {
    UBERON_0000178: ['P11A'],
    UBERON_0000955: ['P12A'],
    UBERON_0000977: ['P9A'],
    UBERON_0001155: ['P11B']
  },
  mus_musculus: {
    UBERON_0000948: ['Heart_and_Aorta', 'Heart_and_Aorta-10X_P7_4'],
    UBERON_0001255: ['Bladder', 'Bladder-10X_P4_3', 'Bladder-10X_P4_4', 'Bladder-10X_P7_7'],
    UBERON_0001723: ['Tongue', 'Tongue-10X_P4_0', 'Tongue-10X_P4_1', 'Tongue-10X_P7_10'],
    UBERON_0001911: ['Mammary_Gland', 'Mammary_Gland-10X_P7_12', 'Mammary_Gland-10X_P7_13'],
    UBERON_0002048: ['Lung', 'Lung-10X_P7_8', 'Lung-10X_P7_9', 'Lung-10X_P8_12', 'Lung-10X_P8_13'],
    UBERON_0002106: ['Spleen', 'Spleen-10X_P4_7', 'Spleen-10X_P7_6'],
    UBERON_0002107: ['Liver', 'Liver-10X_P4_2', 'Liver-10X_P7_0', 'Liver-10X_P7_1'],
    UBERON_0002113: ['Kidney', 'Kidney-10X_P4_5', 'Kidney-10X_P4_6', 'Kidney-10X_P7_5'],
    UBERON_0002370: ['Thymus', 'Thymus-10X_P7_11'],
    UBERON_0002371: ['Marrow', 'Marrow-10X_P7_2', 'Marrow-10X_P7_3'],
    UBERON_0003126: ['Trachea', 'Trachea-10X_P8_14', 'Trachea-10X_P8_15'],
    UBERON_0014892: ['Limb_Muscle', 'Limb_Muscle-10X_P7_14', 'Limb_Muscle-10X_P7_15']
  }
};

var AnatomogramContainerClass =
/** @class */
function (_super) {
  __extends(AnatomogramContainerClass, _super);

  function AnatomogramContainerClass(props) {
    var _this = _super.call(this, props) || this;

    _this.onClick = function (id) {
      var _a = _this.props,
          species = _a.species,
          springContext = _a.springContext;
      var labels = exports.anatomogramToSpringMapping[species][id];
      springContext.toggleLabels(labels);
    };

    _this.onMouseOut = function (id) {
      return;
    };

    _this.onMouseOver = function (id) {
      return;
    };

    _this.parseCategory = function (category) {
      var splitCategories = category.split(/-|_/);
      return splitCategories[0];
    };

    _this.state = {
      ids: Object.keys(exports.anatomogramToSpringMapping[props.species]),
      selectIds: immutable_1.Set()
    };
    return _this;
  }

  AnatomogramContainerClass.prototype.componentDidUpdate = function (prevProps) {
    var _this = this;

    var springContext = this.props.springContext;

    if (!springContext.selectedLabels.equals(prevProps.springContext.selectedLabels)) {
      var selectIds = springContext.selectedLabels.toArray().filter(function (label) {
        return exports.springToAnatomogramMapping[_this.props.species][_this.parseCategory(label)] !== undefined;
      }).map(function (label) {
        return exports.springToAnatomogramMapping[_this.props.species][_this.parseCategory(label)];
      });
      this.setState({
        selectIds: immutable_1.Set(selectIds)
      });
    }
  };

  AnatomogramContainerClass.prototype.render = function () {
    var _a = this.state,
        ids = _a.ids,
        selectIds = _a.selectIds;
    return React.createElement("div", {
      className: 'anatomogram-container',
      style: {
        height: '100%'
      }
    }, React.createElement(anatomogram_1.default, {
      atlasUrl: "",
      highlightColour: 'yellow',
      onClick: this.onClick,
      onMouseOut: this.onMouseOut,
      onMouseOver: this.onMouseOver,
      selectColour: 'ffaa00',
      selectIds: selectIds.toArray(),
      showIds: ids,
      species: this.props.species,
      selectedView: this.props.species === 'mus_musculus' ? 'female' : 'male'
    }));
  };

  AnatomogramContainerClass.defaultProps = {
    height: '300px',
    springContext: __assign({}, context_1.initialSpringContext),
    style: {},
    width: '400px'
  };
  AnatomogramContainerClass.displayName = 'Anatomogram';
  return AnatomogramContainerClass;
}(React.Component);

exports.AnatomogramContainerClass = AnatomogramContainerClass;

exports.AnatomogramContainer = function (props) {
  return React.createElement(context_1.SpringContext.Consumer, null, function (springContext) {
    return React.createElement(AnatomogramContainerClass, __assign({}, props, {
      springContext: springContext
    }));
  });
};